import Vue from 'vue';

const URL_REGEX = /([^\S]|^)(((https?:\/\/)|(www\.))(\S+))/gi;

Vue.filter('link', v => {
  return (v || '')
    .replace(URL_REGEX, (match, space, url) => {
      var hyperlink = url;
      if (!hyperlink.match('^https?://')) {
        hyperlink = 'http://' + hyperlink;
      }
      return space + '<a target="_blank" href="' + hyperlink + '">' + url + '</a>';
    });
});


// WEBPACK FOOTER //
// ./src/filters/faq.js